import { Flex, FlexProps, useTheme } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import styled from '@emotion/styled/macro';
import { FC } from 'react';
import { mq } from 'styles/breakpoints';

interface Props {
  boxWidth: BoxWidth;
  transparent?: boolean;
  includeRightMargin?: boolean;
  animate?: boolean;
}

interface SizesType {
  [id: string]: string;
}

const SIZES: SizesType = {
  xxsWidth: 'calc(25% - 15px)',
  xxsMaxWidth: '360px',
  xsWidth: 'calc(42.84090909090909% - 15px)',
  xsMaxWidth: '362px',
  smWidth: 'calc(57.15909090909091% - 15px)',
  smMaxWidth: '488px',
  mdWidth: 'calc(47.50326797385621% - 15px)',
  mdMaxWidth: '620px',
  smdWidth: '40.52287581699346%',
  smdMaxWidth: '620px',
  lgWidth: 'calc(52.496732026143796% - 15px)',
  lgMaxWidth: '880px',
  xlWidth: 'calc(66.8621700879765% - 15px)',
  xlMaxWidth: '1140px',
  smallHalfWidth: 'calc(50% - 15px)',
  smallHalfMaxWidth: '425px',
  halfWidth: 'calc(50% - 15px)',
  halfMaxWidth: '50%',
  fullWidth: '100%',
  fullMaxWidth: '100%',
};

// @ts-ignore
const BoxContentWrapper = styled(motion(Flex))<Props>(
  (props: Props) => `
    ${mq.md} {
      min-width: ${props.boxWidth === 'half' ? SIZES[`${props.boxWidth}Width`] : 'auto'};
      max-width: ${props.boxWidth === 'half' ? SIZES[`${props.boxWidth}MaxWidth`] : 'initial'};
      margin-right: ${props.boxWidth === 'half' && props.includeRightMargin ? '30px' : '0'};
      margin-bottom: ${props.boxWidth === 'half' ? '0' : '30px'};
    }

    ${mq.lg} {
      min-width: ${SIZES[`${props.boxWidth}Width`]};
      max-width: ${SIZES[`${props.boxWidth}MaxWidth`]};
      margin-right: ${props.includeRightMargin ? '30px' : '0'};
      margin-bottom: 0;
    }
  `,
);

const BoxContent: FC<Props & FlexProps> = ({ children, boxWidth, includeRightMargin, transparent, animate, ...props }) => {
  const { colors } = useTheme();

  return (
    // @ts-ignore
    <BoxContentWrapper
      direction="column"
      mb="30px"
      boxWidth={boxWidth}
      includeRightMargin={includeRightMargin}
      initial={animate ? { opacity: 0, y: -25 } : { opacity: 1, y: 0 }}
      // @ts-ignore
      animate={{ opacity: 1, y: 0 }}
      // @ts-ignore
      transition={{
        type: 'tween',
        duration: 0.2,
        ease: 'easeInOut',
      }}
      sx={{
        background: 'transparent',
        [mq.md]: {
          background: transparent ? 'transparent' : colors.white,
        },
      }}
      layerStyle="whiteBox"
      {...props}
    >
      {children}
    </BoxContentWrapper>
  );
};

export default BoxContent;
